<template>
  <div class="stargate-log-page">
    <div class="stargate-log-search">
      <input
        class="outlined"
        type="text"
        placeholder="חיפוש: טלפון / אימייל / שם / משרה"
        v-model="search_term"
        @input="onSearchInput"
      >
      <button v-if="search_term" class="button" @click="clearSearch">נקה</button>
    </div>
    <datatable
      title="לוג סטארגייט — הגשות מועמדים מהלוחות"
      :is_createable="false"
      :show_edit="false"
      :show_delete="false"
      :show_operations="false"
      :show_header_filter="false"
      :fields="fields"
      :response="data"
    >
    </datatable>
    <div class="stargate-log-pager">
      <button class="button" :disabled="page <= 1" @click="goToPage(page - 1)">← הקודם</button>
      <span class="pager-info">עמוד {{ page }} מתוך {{ totalPages }} ({{ total }} הגשות)</span>
      <button class="button" :disabled="page >= totalPages" @click="goToPage(page + 1)">הבא →</button>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'stargate-log-page',
  data () {
    return {
      per: 100,
      total: 0,
      data: [],
      search_term: this.$route.query.search || '',
      search_timeout: null,
      fields: [
        { name: '#', value: 'row_number' },
        { name: 'תאריך', value: 'applied_at', is_time: true },
        { name: 'מקור', value: 'source_label' },
        {
          name: 'מועמד',
          component: 'LinkEntity',
          component_data_path: 'applicant',
          additional_data: { resource_type: 'Applicant' }
        },
        { name: 'טלפון', value: 'applicant_phone' },
        { name: 'משרה', value: 'position_title' },
        { name: 'חברה', value: 'company_name' },
        { name: 'סטטוס', value: 'status' },
        { name: 'מס׳ הצעה', value: 'offer_id' }
      ]
    }
  },
  computed: {
    page () {
      return parseInt(this.$route.query.page, 10) || 1
    },
    search () {
      return this.$route.query.search || ''
    },
    // Single key for both query params: one navigation that changes page and
    // search together still triggers exactly one fetch.
    fetchKey () {
      return this.page + '|' + this.search
    },
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.per))
    }
  },
  created () {
    this.fetchLog()
  },
  beforeDestroy () {
    clearTimeout(this.search_timeout)
  },
  watch: {
    fetchKey () {
      // Keep the box in sync when the route changes from outside (back/forward).
      // Compared trimmed so whitespace the user is still typing is not clobbered.
      if (this.search_term.trim() !== this.search) this.search_term = this.search
      this.fetchLog()
    }
  },
  methods: {
    fetchLog () {
      // Caller#request appends query params without encoding them, so a term
      // containing & or # would corrupt the URL — encode it here.
      const search = this.search ? encodeURIComponent(this.search) : undefined
      this.$network_utils
        .getStargateLog({ page: this.page, per: this.per, search: search })
        .then(res => {
          this.data = (res && res.data) ? res.data : []
          this.total = (res && res.total) ? res.total : 0
        })
        .catch(() => {
          this.$utils.emit('show_toast', { text: 'שגיאה בטעינת לוג סטארגייט', type: 'error' })
        })
    },
    goToPage (target) {
      if (target < 1 || target > this.totalPages) return
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, page: target } })
    },
    onSearchInput () {
      clearTimeout(this.search_timeout)
      this.search_timeout = setTimeout(() => this.applySearch(this.search_term.trim()), 500)
    },
    clearSearch () {
      clearTimeout(this.search_timeout)
      this.search_term = ''
      this.applySearch('')
    },
    applySearch (term) {
      // Pushing an identical query throws a vue-router duplicate-navigation error.
      if (term === this.search) return
      this.$router.push({
        name: this.$route.name,
        query: { ...this.$route.query, search: term || undefined, page: undefined }
      })
    }
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped>
.stargate-log-search {
  display: flex;
  gap: 8px;
  padding: 12px 16px 0;
}
.stargate-log-search input {
  width: 320px;
  max-width: 100%;
}
.stargate-log-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px;
}
.stargate-log-pager .pager-info {
  font-size: 14px;
  color: #555;
}
</style>
